import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Spacer, Cell, Text, Button, Icon, Card, Divider } from '@vinted/web-ui';
import OutsideClick from 'components/OutsideClick';
import SeparatedList from 'components/SeparatedList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LanguageSelectorDropdown = _ref => {
  let {
    languages,
    activeLanguage,
    isMenuOpen,
    hideLanguageMenu,
    onLanguageMenuToggle,
    saveLanguageSelection
  } = _ref;
  const {
    title_short: titleShort
  } = activeLanguage;

  const renderLanguageText = language => {
    const {
      id: activeLanguageId
    } = activeLanguage;
    const activeLanguageProps = {
      theme: 'amplified',
      bold: true
    };
    const props = language.id === activeLanguageId ? activeLanguageProps : {};
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, _objectSpread({
        text: language.title_local
      }, props)), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), /*#__PURE__*/_jsx(Text, _objectSpread({
        text: "(".concat(language.title, ")")
      }, props))]
    });
  };

  const handleOutsideClick = () => {
    hideLanguageMenu();
  };

  const handleLanguageSelection = language => () => {
    saveLanguageSelection(language);
  };

  return /*#__PURE__*/_jsx(OutsideClick, {
    onOutsideClick: handleOutsideClick,
    children: /*#__PURE__*/_jsxs("div", {
      className: "u-ui-padding-left-small",
      children: [/*#__PURE__*/_jsx(Button, {
        text: titleShort.toUpperCase(),
        styling: Button.Styling.Flat,
        size: Button.Size.Medium,
        theme: "muted",
        inline: true,
        truncated: false,
        icon: /*#__PURE__*/_jsx(Icon, {
          name: "dropdown",
          size: Icon.Size.Small,
          color: Icon.Color.Gray3_v2
        }),
        iconPosition: Button.IconPosition.Right,
        onClick: onLanguageMenuToggle,
        aria: {
          'aria-expanded': isMenuOpen
        }
      }), isMenuOpen && /*#__PURE__*/_jsx("div", {
        className: "language-selector__dropdown",
        children: /*#__PURE__*/_jsx(Card, {
          styling: Card.Styling.Elevated,
          children: /*#__PURE__*/_jsx("div", {
            className: "u-overflow-hidden",
            children: /*#__PURE__*/_jsx(SeparatedList, {
              separator: /*#__PURE__*/_jsx(Divider, {}),
              children: languages.map(language => /*#__PURE__*/_jsx(Cell, {
                type: Cell.Type.Navigating,
                onClick: handleLanguageSelection(language),
                children: renderLanguageText(language)
              }, language.id))
            })
          })
        })
      })]
    })
  });
};

export default LanguageSelectorDropdown;